/**
 * Utility to strip frontend-only fields from a Tire object before DB operations.
 * Removes: reviews, avgRating, salePrice (camelCase), vehicleTypes (camelCase), and any other non-DB fields.
 * Optionally, you can extend this list as needed.
 */

const NON_DB_FIELDS = [
  'reviews',
  'avgRating',
  'vehicleTypes',
  // 'stock', // Do NOT strip stock, it is a DB field
  // Add more frontend-only fields here if needed
];

export function stripNonDbFields<T extends Record<string, unknown>>(obj: T): Partial<T> {
  if (!obj || typeof obj !== 'object') return obj;
  const result: Record<string, unknown> = {};
  for (const key in obj) {
    if (!NON_DB_FIELDS.includes(key)) {
      result[key] = obj[key];
    }
  }
  return result as Partial<T>;
}
